<template>
  <div>
    <p class="caption mb-4" style="color: rgba(0,0,0,0.55)">Defina o tipo de cálculo, as metas e o valor do bônus por modelo.</p>

    <!-- Bloco Meta do Modelo: sempre informada, vem do objetivo. Os tres
         seletores abaixo pertencem so a ela — nao tem relacao com a meta
         do participante, que fica em bloco proprio mais abaixo (Task 8
         layout: bloco em largura cheia em vez de dividir a linha). -->
    <div class="mb-3" style="border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 12px 14px; background: rgba(0,0,0,0.04)">
      <div class="d-flex justify-space-between align-center mb-3">
        <p class="caption font-weight-bold text-uppercase ma-0" style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)">Meta do Modelo</p>
        <v-btn icon x-small @click="mostrarAjudaModelo = !mostrarAjudaModelo" :title="mostrarAjudaModelo ? 'Fechar ajuda' : 'O que significa cada opção?'">
          <v-icon small color="grey darken-1">mdi-help-circle-outline</v-icon>
        </v-btn>
      </div>
      <div class="d-flex" style="gap: 10px; align-items: stretch; flex-wrap: wrap">
        <div style="flex: 1 1 0; min-width: 140px; display: flex; flex-direction: column; border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 10px 12px; background: white">
          <p class="caption font-weight-bold text-uppercase ma-0 mb-2" style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)">Tipo de Meta</p>
          <div class="d-flex" style="gap: 6px; flex: 1">
            <button
              v-for="opt in tiposMeta"
              :key="opt.value"
              type="button"
              @click="setTipoMeta(opt.value)"
              class="rounded pa-2 text-center caption font-weight-medium flex-grow-1"
              style="cursor: pointer; border: 2px solid; transition: all 0.2s; font-family: inherit; outline: none; -webkit-appearance: none; appearance: none"
              :style="form.tipoMeta === opt.value ? 'border-color: #1976d2; background: rgba(25,118,210,0.06); color: #1976d2' : 'border-color: rgba(0,0,0,0.12); background: white; color: rgba(0,0,0,0.6)'"
            >{{ opt.label }}</button>
          </div>
        </div>
        <div style="flex: 1 1 0; min-width: 140px; display: flex; flex-direction: column; border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 10px 12px; background: white">
          <p class="caption font-weight-bold text-uppercase ma-0 mb-2" style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)">Tipo de Cálculo</p>
          <div class="d-flex" style="gap: 6px; flex: 1">
            <button
              v-for="opt in tiposCalculo"
              :key="opt.value"
              type="button"
              @click="setTipoCalculo(opt.value)"
              class="rounded pa-2 text-center caption font-weight-medium flex-grow-1"
              style="cursor: pointer; border: 2px solid; transition: all 0.2s; font-family: inherit; outline: none; -webkit-appearance: none; appearance: none"
              :style="form.tipoCalculo === opt.value ? 'border-color: #1976d2; background: rgba(25,118,210,0.06); color: #1976d2' : 'border-color: rgba(0,0,0,0.12); background: white; color: rgba(0,0,0,0.6)'"
            >{{ opt.label }}</button>
          </div>
        </div>
        <div style="flex: 1 1 0; min-width: 140px; display: flex; flex-direction: column; border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 10px 12px; background: white">
          <p class="caption font-weight-bold text-uppercase ma-0 mb-2" style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)">Tipo de Pagamento</p>
          <div class="d-flex" style="gap: 6px; flex: 1">
            <button
              v-for="opt in tiposPagamento"
              :key="opt.value"
              type="button"
              @click="setTipoPagamento(opt.value)"
              class="rounded pa-2 text-center caption font-weight-medium flex-grow-1"
              style="cursor: pointer; border: 2px solid; transition: all 0.2s; font-family: inherit; outline: none; -webkit-appearance: none; appearance: none"
              :style="form.tipoPagamento === opt.value ? 'border-color: #1976d2; background: rgba(25,118,210,0.06); color: #1976d2' : 'border-color: rgba(0,0,0,0.12); background: white; color: rgba(0,0,0,0.6)'"
            >{{ opt.label }}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Ajuda do bloco Meta do Modelo: fechada por padrao (mostrarAjudaModelo),
         alternada pelo botao acima. So as descricoes dos tres seletores do
         modelo — a camada do participante tem sua propria ajuda mais abaixo. -->
    <v-alert v-if="mostrarAjudaModelo && form.tipoCalculo" type="info" dense text class="caption mb-3">
      <div class="mb-1"><strong>Meta:</strong> {{ descricaoTipoMeta }}</div>
      <div v-if="descricaoTipoCalculo" class="mb-1"><strong>Cálculo:</strong> {{ descricaoTipoCalculo }}</div>
      <div class="mb-2"><strong>Pagamento:</strong> {{ descricaoTipoPagamento }}</div>
      <div class="text-right">
        <v-btn x-small text color="primary" @click="mostrarAjudaModelo = false">Fechar</v-btn>
      </div>
    </v-alert>

    <!-- Modo Coletivo -->
    <template v-if="form.tipoMeta !== 'individual'">
      <div v-if="form.modelosSelecionados.length > 0" class="mb-4" style="border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 10px 12px; background: rgba(0,0,0,0.015)">
        <p class="caption font-weight-bold text-uppercase ma-0 mb-2" style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)">Metas por Modelo</p>
        <div v-for="m in form.modelosSelecionados" :key="m.id_produto" class="pa-3 rounded mb-2" style="background: white; border: 1px solid rgba(0,0,0,0.12)">
          <p class="caption font-weight-medium mb-2" style="color: rgba(0,0,0,0.7)">{{ nomeModelo(m) }}</p>
          <template v-if="form.tipoCalculo === 2">
            <div class="d-flex justify-space-between align-center mb-2">
              <span class="caption grey--text text--darken-1">Faixas de Quantidade</span>
              <v-btn x-small outlined color="primary" @click="adicionarFaixaItem(m.id_produto)">
                <v-icon x-small class="mr-1">mdi-plus</v-icon>Adicionar Faixa
              </v-btn>
            </div>
            <div v-for="(faixa, idx) in getFaixasItem(m.id_produto)" :key="idx" class="mb-2 pa-3 rounded" style="background: rgba(0,0,0,0.02); border: 1px solid rgba(0,0,0,0.08)">
              <div class="d-flex align-end" style="gap: 8px">
                <v-text-field :value="faixa.minimo" @input="atualizarFaixaItem(m.id_produto, idx, 'minimo', $event)" label="Mínimo" type="number" dense outlined style="flex: 1" :hide-details="!getFaixaOrdemErroItem(m.id_produto, idx)" :error-messages="getFaixaOrdemErroItem(m.id_produto, idx)"></v-text-field>
                <v-text-field :value="faixa.maximo" @input="atualizarFaixaItem(m.id_produto, idx, 'maximo', $event)" label="Máximo" type="number" dense outlined hide-details style="flex: 1"></v-text-field>
                <v-text-field :value="faixa.bonus" @input="atualizarFaixaItem(m.id_produto, idx, 'bonus', $event)" :label="form.tipoPagamento === 1 ? 'R$ / unidade' : 'Bônus fixo (R$)'" type="number" dense outlined hide-details style="flex: 1"></v-text-field>
                <v-btn v-if="getFaixasItem(m.id_produto).length > 2" icon x-small color="error" @click="removerFaixaItem(m.id_produto, idx)" class="mb-1 flex-shrink-0"><v-icon small>mdi-close</v-icon></v-btn>
              </div>
            </div>
            <v-alert v-if="getFaixasItem(m.id_produto).length < 2" type="warning" dense text class="mt-2 caption mb-0">Adicione pelo menos 2 faixas para continuar.</v-alert>
          </template>
          <template v-else>
            <div class="d-flex" style="gap: 8px">
              <v-text-field :value="getMetaItemValor(m.id_produto, 'metaValor')" @input="setMetaItemValor(m.id_produto, 'metaValor', $event)" label="Qtde Meta" type="number" dense outlined placeholder="0" hide-details style="flex: 1"></v-text-field>
              <v-text-field :value="getMetaItemValor(m.id_produto, 'valorBonus')" @input="setMetaItemValor(m.id_produto, 'valorBonus', $event)" :label="form.tipoPagamento === 1 ? 'Bônus / unidade (R$)' : 'Bônus fixo (R$)'" prefix="R$" type="number" dense outlined placeholder="0,00" hide-details style="flex: 1"></v-text-field>
            </div>
          </template>
        </div>
      </div>
    </template>

    <!-- Modo Individual -->
    <template v-else-if="form.modelosSelecionados.length > 0 && form.colaboradoresSelecionados.length > 0">

      <!-- Individual — Meta Fixa -->
      <template v-if="form.tipoCalculo !== 2">
        <div
          v-for="colab in form.colaboradoresSelecionados"
          :key="colab.id_colaborador"
          class="mb-3"
          style="border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 12px 14px; background: rgba(0,0,0,0.015)"
        >
          <p class="body-2 font-weight-medium ma-0 mb-1" style="color: rgba(0,0,0,0.75)">{{ colab.colaborador }}</p>
          <p class="caption grey--text ma-0 mb-3">{{ colab._funcao }}</p>
          <div v-for="m in form.modelosSelecionados" :key="m.id_produto" class="mb-2 pa-3 rounded" style="background: white; border: 1px solid rgba(0,0,0,0.12)">
            <p class="caption font-weight-medium ma-0 mb-2" style="color: rgba(0,0,0,0.7)">{{ nomeModelo(m) }}</p>
            <div class="d-flex" style="gap: 8px">
              <v-text-field
                :value="getIndividualItemValor(colab.id_colaborador, m.id_produto, 'metaValor')"
                @input="setIndividualItemValor(colab.id_colaborador, m.id_produto, 'metaValor', $event)"
                label="Qtde Meta" type="number" dense outlined placeholder="0" hide-details style="flex: 1"
              ></v-text-field>
              <v-text-field
                :value="getIndividualItemValor(colab.id_colaborador, m.id_produto, 'valorBonus')"
                @input="setIndividualItemValor(colab.id_colaborador, m.id_produto, 'valorBonus', $event)"
                :label="form.tipoPagamento === 1 ? 'Bônus / unidade (R$)' : 'Bônus fixo (R$)'" prefix="R$" type="number" dense outlined placeholder="0,00" hide-details style="flex: 1"
              ></v-text-field>
            </div>
          </div>
        </div>
      </template>

      <!-- Individual — Faixa Progressiva -->
      <div v-else style="display: flex; flex-direction: column; gap: 12px">
        <div
          v-for="colab in form.colaboradoresSelecionados"
          :key="colab.id_colaborador"
          style="border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 12px 14px; background: rgba(0,0,0,0.015)"
        >
          <p class="body-2 font-weight-medium ma-0 mb-1" style="color: rgba(0,0,0,0.75)">{{ colab.colaborador }}</p>
          <p class="caption grey--text ma-0 mb-3">{{ colab._funcao }}</p>
          <div v-for="m in form.modelosSelecionados" :key="m.id_produto" class="mb-3">
            <div class="d-flex justify-space-between align-center mb-2">
              <span class="caption font-weight-medium" style="color: rgba(0,0,0,0.7)">{{ nomeModelo(m) }}</span>
              <v-btn x-small outlined color="primary" @click="adicionarFaixaIndividualItem(colab.id_colaborador, m.id_produto)">
                <v-icon x-small class="mr-1">mdi-plus</v-icon>Adicionar Faixa
              </v-btn>
            </div>
            <div v-for="(faixa, idx) in getIndividualItemFaixas(colab.id_colaborador, m.id_produto)" :key="idx" class="mb-2 pa-3 rounded" style="background: white; border: 1px solid rgba(0,0,0,0.1)">
              <div class="d-flex align-end" style="gap: 8px">
                <v-text-field :value="faixa.minimo" @input="atualizarFaixaIndividualItem(colab.id_colaborador, m.id_produto, idx, 'minimo', $event)" label="Mínimo" type="number" dense outlined style="flex: 1" :hide-details="!getFaixaOrdemErroIndividualItem(colab.id_colaborador, m.id_produto, idx)" :error-messages="getFaixaOrdemErroIndividualItem(colab.id_colaborador, m.id_produto, idx)"></v-text-field>
                <v-text-field :value="faixa.maximo" @input="atualizarFaixaIndividualItem(colab.id_colaborador, m.id_produto, idx, 'maximo', $event)" label="Máximo" type="number" dense outlined style="flex: 1" :hide-details="!getFaixaMaximoErroIndividualItem(colab.id_colaborador, m.id_produto, idx)" :error-messages="getFaixaMaximoErroIndividualItem(colab.id_colaborador, m.id_produto, idx)"></v-text-field>
                <v-text-field :value="faixa.bonus" @input="atualizarFaixaIndividualItem(colab.id_colaborador, m.id_produto, idx, 'bonus', $event)" :label="form.tipoPagamento === 1 ? 'R$ / unidade' : 'Bônus fixo (R$)'" type="number" dense outlined hide-details style="flex: 1"></v-text-field>
                <v-btn v-if="getIndividualItemFaixas(colab.id_colaborador, m.id_produto).length > 2" icon x-small color="error" @click="removerFaixaIndividualItem(colab.id_colaborador, m.id_produto, idx)" class="mb-1 flex-shrink-0"><v-icon small>mdi-close</v-icon></v-btn>
              </div>
            </div>
            <v-alert v-if="getIndividualItemFaixas(colab.id_colaborador, m.id_produto).length < 2" type="warning" dense text class="mt-1 caption mb-0">Adicione pelo menos 2 faixas para continuar.</v-alert>
          </div>
        </div>
      </div>

    </template>
    <div v-else-if="form.tipoMeta === 'individual'" class="mb-4">
      <v-alert type="info" dense text class="caption">Selecione colaboradores e modelos nas etapas anteriores para definir metas individuais.</v-alert>
    </div>

    <!-- Bloco Meta do Participante: opcional, mas sempre visivel. Desligado,
         os dois seletores continuam na tela desabilitados e esmaecidos em vez
         de sumir — escondido, ninguem descobre que a opcao existe. So os
         seletores ficam visiveis apagados; parametros da media, tabela de
         metas, campos de valor/referencia do bonus e payload continuam
         ocultos ate o switch ligar. -->
    <div
      class="mb-3"
      :style="form.usaMetaColaborador
        ? 'border: 1px solid rgba(25,118,210,0.3); border-radius: 8px; padding: 12px 14px; background: rgba(25,118,210,0.03)'
        : 'border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 12px 14px; background: rgba(0,0,0,0.04)'"
    >
      <div class="d-flex justify-space-between align-center mb-3">
        <p
          class="caption font-weight-bold text-uppercase ma-0"
          :style="form.usaMetaColaborador ? 'letter-spacing: 0.05em; font-size: 10px; color: #1976d2' : 'letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)'"
        >Meta do Participante</p>
        <div class="d-flex align-center" style="gap: 4px">
          <v-btn icon x-small @click="mostrarAjudaParticipante = !mostrarAjudaParticipante" :title="mostrarAjudaParticipante ? 'Fechar ajuda' : 'O que significa cada opção?'">
            <v-icon small color="grey darken-1">mdi-help-circle-outline</v-icon>
          </v-btn>
          <v-switch
            :input-value="form.usaMetaColaborador"
            @change="setUsaMetaColaborador"
            dense
            hide-details
            class="ma-0 pa-0"
          ></v-switch>
        </div>
      </div>

      <!-- Ajuda do bloco Meta do Participante: independente da ajuda do
           modelo (mostrarAjudaParticipante). Fica disponivel mesmo com o
           switch desligado — e o que explica ao usuario o que a
           funcionalidade faz, para ele decidir se liga. -->
      <v-alert v-if="mostrarAjudaParticipante" type="info" dense text class="caption mb-3">
        <div class="mb-1"><strong>Meta do colaborador:</strong> {{ descricaoMetaColaborador }}</div>
        <div v-if="form.usaMetaColaborador" class="mb-1"><strong>Origem da meta:</strong> {{ descricaoOrigemMeta }}</div>
        <div v-if="form.usaMetaColaborador" class="mb-2"><strong>Origem do bônus:</strong> {{ descricaoOrigemBonusColaborador }}</div>
        <div class="text-right">
          <v-btn x-small text color="primary" @click="mostrarAjudaParticipante = false">Fechar</v-btn>
        </div>
      </v-alert>

      <!-- Task 10: switch desligado apaga o conjunto inteiro (titulos, caixas
           e botoes) com opacity reduzida no container — sinaliza "desabilitado"
           sem depender so do estado :disabled dos botoes la dentro. O switch
           e o titulo "Meta do Participante" ficam fora deste div de proposito,
           entao continuam com aparencia normal mesmo desligado.
           Task 12: com o cinza uniforme (sem azul competindo) em
           estiloSeletorParticipante, a opacidade subiu de 0.55 para 0.75 —
           em 0.55 os rotulos (cor rgba(0,0,0,0.3)) ficavam ilegiveis. -->
      <div class="d-flex mb-3" style="gap: 10px; flex-wrap: wrap" :style="{ opacity: form.usaMetaColaborador ? 1 : 0.75 }">
        <div style="flex: 1 1 0; min-width: 140px; display: flex; flex-direction: column; border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 10px 12px; background: white">
          <p class="caption font-weight-bold text-uppercase ma-0 mb-2" style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)">Origem da meta do colaborador</p>
          <div class="d-flex" style="gap: 6px; flex: 1">
            <button
              v-for="opt in origensMeta"
              :key="opt.value"
              type="button"
              :disabled="!form.usaMetaColaborador"
              @click="setOrigemMeta(opt.value)"
              class="rounded pa-2 text-center caption font-weight-medium flex-grow-1"
              style="border: 2px solid; transition: all 0.2s; font-family: inherit; outline: none; -webkit-appearance: none; appearance: none"
              :style="estiloSeletorParticipante(form.origemMeta === opt.value)"
            >{{ opt.label }}</button>
          </div>
        </div>
        <div style="flex: 1 1 0; min-width: 140px; display: flex; flex-direction: column; border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 10px 12px; background: white">
          <p class="caption font-weight-bold text-uppercase ma-0 mb-2" style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)">Origem do bônus do colaborador</p>
          <div class="d-flex" style="gap: 6px; flex: 1">
            <button
              v-for="opt in origensBonusColaborador"
              :key="opt.value"
              type="button"
              :disabled="!form.usaMetaColaborador"
              @click="setOrigemBonusColaborador(opt.value)"
              class="rounded pa-2 text-center caption font-weight-medium flex-grow-1"
              style="border: 2px solid; transition: all 0.2s; font-family: inherit; outline: none; -webkit-appearance: none; appearance: none"
              :style="estiloSeletorParticipante(form.origemBonusColaborador === opt.value)"
            >{{ opt.label }}</button>
          </div>
        </div>
      </div>

      <template v-if="form.usaMetaColaborador">
        <v-text-field
          v-if="form.origemBonusColaborador === 1"
          :value="form.valorBonusColaborador"
          @input="setValorBonusColaborador"
          @blur="valorBonusColaboradorTocado = true"
          label="Valor do bônus"
          prefix="R$"
          type="number"
          dense
          outlined
          :hide-details="!(valorBonusColaboradorTocado && erroValorBonusColaborador)"
          :error-messages="valorBonusColaboradorTocado ? erroValorBonusColaborador : ''"
          class="mb-1"
        ></v-text-field>

        <BonusComissaoReferencia v-if="form.origemBonusColaborador === 2" :form="form" />
      </template>
    </div>

    <SeletorOrigemMeta v-if="form.usaMetaColaborador" :form="form" @change-parametros="agendarRecalculo" />

    <TabelaMetasCalculadas
      v-if="form.usaMetaColaborador"
      ref="tabelaMetas"
      :form="form"
      :campanha="campanha"
    />

    <!-- Task 15: aviso neutro (cinza, sem type="error") consolidando as
         pendencias das tres camadas acima (bonus, parametros da media,
         metas dos participantes) num so lugar — em vez de repetir a mesma
         informacao em varios alertas vermelhos, aqui so quando falta algo
         e independente de qualquer campo ter sido tocado, porque e isto que
         explica o botao Salvar desabilitado. -->
    <v-alert
      v-if="pendenciasParticipante.length > 0"
      dense
      text
      color="grey darken-2"
      icon="mdi-information-outline"
      class="caption mb-3"
    >
      Para salvar, informe: {{ pendenciasParticipante.join(", ") }}.
    </v-alert>

    <CustoEstimadoCard
      :custo-estimado="custoEstimado"
      :n-colaboradores="form.colaboradoresSelecionados.length"
      :descricao-preenchido="descricaoPreenchido"
      descricao-vazio="Preencha as metas e bônus dos modelos acima para visualizar a simulação de custo."
    />

    <v-expansion-panels v-if="mostrarPayload" flat class="mt-3">
      <v-expansion-panel style="background: rgba(0,0,0,0.02); border: 1px solid rgba(0,0,0,0.12); border-radius: 8px">
        <v-expansion-panel-header class="caption font-weight-medium py-2" style="min-height: 36px; color: rgba(0,0,0,0.6)">
          Ver payload da meta
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <pre class="caption ma-0" style="white-space: pre-wrap; word-break: break-word; color: rgba(0,0,0,0.7)">{{ payloadPreview }}</pre>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import calculoMixin from "./calculoMixin";
import CustoEstimadoCard from "./CustoEstimadoCard";
import SeletorOrigemMeta from "./SeletorOrigemMeta";
import TabelaMetasCalculadas from "./TabelaMetasCalculadas";
import BonusComissaoReferencia from "./BonusComissaoReferencia";
import { calcPorColaboradorItens, gerarLinhasItens, calcCustoParticipante, bonusParticipantePorColaborador } from "./custoEstimadoUtils";
import { montarExtrasMeta } from "../payloadMetaExtras";
import { pendenciasMetaColaborador } from "../metaColaboradorValidacaoUtils";
import { formatarNomeModelo } from "../nomeModeloUtils";

export default {
  name: "SubEtapaCalculoModelo",

  mixins: [calculoMixin],

  components: { CustoEstimadoCard, SeletorOrigemMeta, TabelaMetasCalculadas, BonusComissaoReferencia },

  props: {
    form: { type: Object, required: true },
    // So repassado para TabelaMetasCalculadas, para resolver a competencia
    // (mes_ref/ano_ref) do bonus por "% sobre referencia" — ver
    // buscarComissaoReferenciaSeNecessario la.
    campanha: { type: Object, default: () => ({}) }
  },

  data() {
    return {
      metasTick: 0,
      mostrarAjudaModelo: false,
      mostrarAjudaParticipante: false,
      // Task 15: "campo tocado" e estado local de UI, nunca do form — nao e
      // dado da meta, nao entra no payload. Comeca falso a cada vez que a
      // secao liga (ver setUsaMetaColaborador), entao o campo abre limpo e
      // so mostra erro depois que o usuario encosta e sai dele (@blur).
      valorBonusColaboradorTocado: false,
      origensMeta: [
        { value: 1, label: "Informada" },
        { value: 2, label: "Média histórica" }
      ],
      origensBonusColaborador: [
        { value: 1, label: "Informado" },
        { value: 2, label: "% sobre referência" }
      ]
    };
  },

  watch: {
    "form.metasModelos": { deep: true, handler() { this.metasTick++; } },
    "form.metasIndividuaisItens": { deep: true, handler() { this.metasTick++; } },
    "form.metasCalculadas": { deep: true, handler() { this.metasTick++; } },

    // Task 4: participante adicionado depois do calculo original nao pode
    // ficar sem meta em silencio. colaboradoresSelecionados so muda na
    // sub-etapa 1 (Participantes), que desmonta este componente (v-else-if
    // na etapa 4) — entao a mudanca real so aparece aqui quando o usuario
    // volta para a etapa 1, adiciona alguem e avanca de novo, remontando
    // este componente com o array ja atualizado. Por isso immediate: true:
    // sem ele, o watch nunca dispararia nesse fluxo, so em change futura
    // com o componente ja montado (que a arquitetura atual nao produz).
    // Sem risco de laco: agendarRecalculo/recalcular so escrevem em
    // form.metasCalculadas (via mesclarMetasCalculadas, que preserva as
    // metas manuais), nunca em form.colaboradoresSelecionados — esse watch
    // nao se auto-dispara.
    "form.colaboradoresSelecionados": {
      immediate: true,
      handler() {
        if (this.form.usaMetaColaborador && this.form.origemMeta === 2) {
          this.agendarRecalculo();
        }
      }
    }
  },

  computed: {
    descricaoPreenchido() {
      const participante = calcCustoParticipante(this.form);
      const base = this.form.tipoCalculo === 2
        ? "Simulação com atingimento da última faixa de todos os modelos"
        : "Simulação com 100% de atingimento para todos";
      // O bonus por "% sobre referencia" agora entra na conta, mas continua
      // sendo estimativa sobre a comissao de um mes que ainda nao fechou —
      // o texto precisa dizer isso, senao o numero e lido como definitivo.
      return participante.sobreReferencia
        ? `${base}. O bônus do participante usa a comissão P2 da competência de referência, que ainda cresce até o mês fechar — o valor pago pode ser maior.`
        : base;
    },

    // Custo estimado da meta do modelo (sempre ativa) somado ao bonus do
    // participante — origem Informado (valor fixo por colaborador que bate a
    // meta) ou "% sobre referencia" (percentual sobre a comissao P2 de cada
    // um na competencia, buscada por TabelaMetasCalculadas).
    // calcCustoParticipante e a mesma funcao usada em
    // ModalCadastroMeta.custoEstimado: garante que o card desta etapa e o
    // resumo lateral nunca mostrem numeros diferentes de novo.
    custoEstimado() {
      void this.metasTick;
      const form = this.form;
      const participante = calcCustoParticipante(form);
      // No modo individual cada colaborador tem o seu proprio bonus quando a
      // origem e "% sobre referencia" — a media de calcCustoParticipante
      // serviria pro total, mas erraria cada linha.
      const bonusPorColaborador = bonusParticipantePorColaborador(form);
      if (form.tipoMeta === "individual") {
        let total = 0;
        const linhas = [];
        form.colaboradoresSelecionados.forEach(c => {
          const colItens = (form.metasIndividuaisItens || {})[c.id_colaborador] || {};
          let colTotal = 0;
          if (form.tipoCalculo !== 2) {
            form.modelosSelecionados.forEach(m => {
              const item = colItens[m.id_produto] || {};
              const meta = parseFloat(item.metaValor) || 0;
              const bonus = parseFloat(item.valorBonus) || 0;
              colTotal += form.tipoPagamento === 1 ? meta * bonus : bonus;
            });
          } else {
            form.modelosSelecionados.forEach(m => {
              const faixas = (colItens[m.id_produto] || {}).faixas || [];
              if (faixas.length > 0) {
                const last = faixas[faixas.length - 1];
                const qtde = parseFloat(last.maximo) || parseFloat(last.minimo) || 0;
                const bonus = parseFloat(last.bonus) || 0;
                colTotal += form.tipoPagamento === 1 ? qtde * bonus : bonus;
              }
            });
          }
          colTotal += bonusPorColaborador[String(c.id_colaborador)] || 0;
          total += colTotal;
          linhas.push({ label: c.colaborador || String(c.id_colaborador), valor: colTotal });
        });
        return { porColaborador: null, total, nSemanas: 1, linhas, sobreReferencia: participante.sobreReferencia };
      }
      const getKey = m => m.id_produto;
      const getNome = m => formatarNomeModelo(m.cod_modelo, m.descricao_modelo);
      const porColaboradorModelo = calcPorColaboradorItens(
        form.modelosSelecionados, form.metasModelos, getKey, form.tipoCalculo, form.tipoPagamento
      );
      const porColaborador = porColaboradorModelo + participante.porColaborador;
      const linhas = gerarLinhasItens(
        form.modelosSelecionados, form.metasModelos, getKey, getNome, form.tipoCalculo, form.tipoPagamento
      );
      if (participante.porColaborador > 0) {
        linhas.push({
          label: "Bônus do participante",
          detalhe: participante.sobreReferencia
            ? `${form.comissaoPercentual || 0}% da comissão P2 da competência (média por colaborador)`
            : "fixo por colaborador que bate a meta",
          valor: participante.porColaborador
        });
      }
      return {
        porColaborador,
        total: porColaborador * (form.colaboradoresSelecionados.length || 1),
        nSemanas: 1,
        linhas,
        sobreReferencia: participante.sobreReferencia
      };
    },

    // Conferencia visual dos campos novos durante a Fase 0, enquanto a API
    // ainda nao os recebe. So aparece quando a meta do colaborador esta ligada,
    // unico caso em que o payload ganha algo alem dos campos do objetivo.
    mostrarPayload() {
      return this.form.usaMetaColaborador;
    },

    payloadPreview() {
      void this.metasTick;
      return JSON.stringify(montarExtrasMeta(this.form), null, 2);
    },

    // Espelha bonusColaboradorValido (origem Informado) em
    // metaColaboradorValidacaoUtils.js: valor zerado/vazio bloqueia o Salvar.
    // O campo usava hide-details fixo e nunca mostrava esse bloqueio ao
    // usuario — agora aparece igual ao padrao ja usado em erroPiso.
    erroValorBonusColaborador() {
      if (this.form.origemBonusColaborador !== 1) return "";
      const valor = parseFloat(this.form.valorBonusColaborador);
      return valor > 0 ? "" : "Informe um valor maior que zero";
    },

    // Task 15: consolida num aviso so o que falta nas tres camadas da meta
    // do colaborador (bonus, parametros da media, metas dos participantes).
    // Reaproveita a mesma logica que decide o bloqueio do Salvar
    // (metaColaboradorValida), so que como texto — nao muda o que bloqueia,
    // so explica.
    pendenciasParticipante() {
      void this.metasTick;
      return pendenciasMetaColaborador(this.form);
    }
  },

  methods: {
    // Task 21: nome do modelo para exibicao — cod_modelo so existe no
    // catalogo de criacao (ModalCadastroSubEtapaObjetivo.carregarModelos);
    // ao reabrir uma meta salva, m.descricao_modelo e o unico campo
    // disponivel (metaInfoMap/editarMeta em ModalCadastroMeta.vue). Ver
    // nomeModeloUtils para a regra completa.
    nomeModelo(m) {
      return formatarNomeModelo(m.cod_modelo, m.descricao_modelo);
    },

    // Debounce: o usuario digita "15" caractere a caractere; sem isso
    // recalcularia a cada tecla.
    agendarRecalculo() {
      clearTimeout(this._recalculoTimer);
      this._recalculoTimer = setTimeout(() => {
        const tabela = this.$refs.tabelaMetas;
        if (tabela && tabela.podeCalcular) tabela.recalcular();
      }, 400);
    },

    // Diferente do antigo seletor de Escopo em SeletorOrigemMeta.vue
    // (git 2875bead), aqui o valor corrente (origemMeta/origemBonusColaborador)
    // nao importa enquanto o switch esta desligado — nao vai pro payload nem
    // configura nada. Por isso, desabilitado, todas as opcoes recebem o mesmo
    // cinza neutro (nenhuma azul), para o bloco nao parecer configurado e
    // funcionando. Com o switch ligado, a opcao ativa volta a ficar em azul.
    estiloSeletorParticipante(ativo) {
      const desabilitado = !this.form.usaMetaColaborador;
      if (desabilitado) {
        return "border-color: rgba(0,0,0,0.08); background: rgba(0,0,0,0.03); color: rgba(0,0,0,0.3); cursor: not-allowed";
      }
      if (ativo) {
        return "border-color: #1976d2; background: rgba(25,118,210,0.06); color: #1976d2; cursor: pointer";
      }
      return "border-color: rgba(0,0,0,0.12); background: white; color: rgba(0,0,0,0.6); cursor: pointer";
    },

    // Guarda contra o clique no seletor desabilitado (Task 8, item 4): o
    // atributo `disabled` do <button> ja bloqueia por si, mas a guarda aqui
    // e a defesa que sobrevive mesmo se uma refatoracao futura trocar o
    // <button> estilizado por outro elemento sem `disabled` nativo.
    setOrigemMeta(val) {
      if (!this.form.usaMetaColaborador) return;
      if (this.form.origemMeta === val) return;
      this.$set(this.form, "origemMeta", val);
      this.$set(this.form, "metasCalculadas", {});
      this.agendarRecalculo();
    },

    setOrigemBonusColaborador(val) {
      if (!this.form.usaMetaColaborador) return;
      this.$set(this.form, "origemBonusColaborador", val);
    },

    setValorBonusColaborador(valor) {
      this.$set(this.form, "valorBonusColaborador", valor);
    },

    // Task 15: desligar reseta o "tocado" do valor do bonus — os demais
    // campos com essa nocao (piso em SeletorOrigemMeta, percentual em
    // BonusComissaoReferencia) vivem em componentes filhos que sao
    // desmontados pelo v-if quando o switch desliga, entao ja voltam limpos
    // sozinhos ao remontar. Este aqui e o unico que mora nesta instancia e
    // sobrevive ao toggle, entao precisa de reset explicito.
    setUsaMetaColaborador(val) {
      this.$set(this.form, "usaMetaColaborador", !!val);
      if (!val) this.valorBonusColaboradorTocado = false;
    }
  }
};
</script>
